import './modules/banner'
import './modules/carrousel'
import './modules/calendar'
import './modules/massonry'